<template>
    <div class="myProcessListView-list">
        <el-container>
            <el-header style="height: auto; padding-top: 8px;">
                    <div v-if="!isShowNewMode || isProjectMainLine " class="tools-bar" @keyup.enter="handleSearch">
                        <el-form style="margin-top:10px;" :inline="true" class="demo-form-inline">
                            <el-form-item label="发起类型">
                                <el-select style="width: 200px;" v-model="processStartedBy" @change="handleSearch" placeholder="请选择">
                                    <el-option
                                        v-for="item in processStartedByList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="流程名称">
                                <el-input maxlength="100" v-model.trim="searchKeyWord" placeholder="">
                                    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                                </el-input>
                            </el-form-item>
                        </el-form>
                        <div class="tools-btn-group" style="margin-left:30%;margin-top:10px;">
                            <el-button v-if="(!isShowNewMode && !hideModeSwich)"  circle icon="el-icon-s-grid" title='块模式' @click="handleModeSwitch"></el-button>
                        </div>
                    </div>
                    <div v-if="isShowNewMode" style="margin-top:15px;float: left;">
                        <el-form :inline="true" class="demo-form-inline">
                          <el-row>
                            <el-form-item v-if="!isFromBusTab" label="应用名称">
                                <el-select style="width: 160px;" filterable clearable v-model="selectedAppId" @change="changeSelectedAppId" @clear="clearSelectedAppId"  placeholder="请选择">
                                    <el-option
                                        v-for="item in appsList"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="流程模板">
                                <el-select style="width: 120px;" multiple filterable clearable v-model="selectedProcessServiceIdArray" @change="handleSearch"  placeholder="请选择模板">
                                    <el-option
                                        v-for="item in currentTemplateList"
                                        :key="item.processServiceId"
                                        :label="item.templateName"
                                        :value="item.processServiceId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="流程名称">
                                <el-input style="width: 160px;" v-model="searchParams.serviceName" ></el-input>
                                <!-- <el-select
                                    style="width: 180px;"
                                    v-model="searchParams.processInstanceId"
                                    filterable
                                    remote
                                    clearable
                                    reserve-keyword
                                    placeholder="请选择流程名称"
                                    :remote-method="queryProcessList"
                                    :loading="processNameLoading"
                                    @change="selectProcessNameTrigger">
                                    <el-option
                                        v-for="item in processList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select> -->
                            </el-form-item>
                            <el-form-item v-if="role !== 'startedBy'" label="发起人">
                                <el-input title='流程发起人' readonly style="width: 90px;" v-model="selectedStartedUser.selectedUserNames" @focus="chooseProcessStartedUser" ></el-input>
                                <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowStartedUserOrg'  :selectedUser="selectedStartedUser" ref="startedUserOrgPop" @nodeClick="processStartedUserSelectTrigger" />
                            </el-form-item>
                            <el-form-item  v-if="role !== 'assignee'"  label="负责人">
                                <el-input :title='selectedProcessUser.selectedUserNames' readonly style="width: 90px;" v-model="selectedProcessUser.selectedUserNames" @focus="chooseProcessAssigneeUser" ></el-input>
                                <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowProcessUserOrg' :multiple='true' :selectedUser="selectedProcessUser" ref="processUserOrgPop" @nodeClick="processAssigneeSelectTrigger" />
                            </el-form-item>
                            <el-form-item label="子流程">
                                <el-select style="width: 110px;" @change="handleSearch" v-model="searchParams.hasSubProcess" placeholder="请选择">
                                    <el-option
                                        v-for="item in processInstanceTypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="isFromBusTab" label="流程角色">
                                <el-select style="width: 90px;" @change="handleSearch" v-model="searchParams.processStartedBy"  placeholder="请选择">
                                    <el-option
                                        v-for="item in processStartedByList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-button type="primary" icon="el-icon-search" circle @click="handleSearch"></el-button>
                            <el-button icon="el-icon-menu" type="primary" circle title="菜单模式"  @click="changeMenuMode"></el-button>
                            <el-button icon="el-icon-bottom" type="primary" circle title="导出数据"  @click="exportData"></el-button>
                            <!-- <el-button v-if="isListView"  circle icon="el-icon-s-grid" title='块模式' @click="handleModeSwitch"></el-button> -->
                        </el-row>
                    </el-form>
                    <el-tooltip class="item" effect="light" content="全树模式（只要有符合条件的，就会把整颗树展示出来）;默认模式（只展示与我相关的流程，其他不相关的主子流程将不展示）。选择后会将模式自动记忆，下次进来还是展示您上次选择的模式。" placement="top">
                        <el-checkbox style='float:left' class="checkBox-style" v-model="searchParams.complateTreeMode"  @change="handleByMeModeChange"><el-tag size="mini">全树模式</el-tag></el-checkbox>
                    </el-tooltip>
                </div>
            </el-header>
            <el-main class="table-main">
                <el-table :key="loadTableTimer" v-if="isListView && !isShowNewMode" :height="tableHeight" :data="instancesListTemp" :style="tableStyle" v-loading="loading" border  stripe>
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="name" label="流程名称"   :show-overflow-tooltip="true" ></el-table-column>
                    <el-table-column prop="templateName"   :show-overflow-tooltip="true" label="流程模板" width="170"></el-table-column>
                    <el-table-column label="当前任务" :show-overflow-tooltip="true" width="300" v-if="!isSearchNowTasks" >
                        <template slot-scope="scope" >
                          <AsynCurrentTasksColumn
                              v-if="!scope.row.finish"
                              :readOnly="true"
                              :isShowOverflowTooltip="true"
                              :cellValue="scope.row['templateName']"
                              :processInstanceId="scope.row['id']"
                              :processInstanceName="scope.row['name']"
                              :processInstanceStatus="scope.row['processInstanceStatus']"
                              :createdByName="scope.row['assigneeUserName']"
                              :createdDate="scope.row['started']"
                              :columnRow="scope.row"
                              :rowNumer="scope.$index"
                              :closeFirstTaskCanDeleteBtn="searchParams.complateTreeMode"
                              @refreshTableBtn="refreshTableBtn"
                          />
                          <el-tag v-if="scope.row.finish" type="primary" size="small">流程已完成</el-tag>
                      </template>
                    </el-table-column>
                    
                     <el-table-column label="当前任务" :show-overflow-tooltip="true"  width="300" v-if="isSearchNowTasks" >
                        <template slot-scope="scope" >
                          <CurrentTasksColumn
                              v-if="!scope.row.finish" 
                              :isFromBusTab="false"
                              :isShowOverflowTooltip="true"
                              :cellValue="scope.row['templateName']"
                              :taskInstanceList="scope.row['currentTasks']"
                              :processInstanceId="scope.row['id']"
                              :processInstanceName="scope.row['name']"
                              :createdByName="scope.row['assigneeUserName']"
                              :createdDate="scope.row['started']"
                              :readOnly='true'
                          />
                          <el-tag v-if="scope.row.finish" type="primary" size="small">流程已完成</el-tag>
                            <!-- <el-tooltip v-if="scope.row.hasApproval === '1'" content="多条审批流时默认只显示最近一条审批流状态" slot="reference"  effect="light" placement="top">
                                <div class="approvalStatus" style="font-size: 13px;">
                                    <span :class="activeClass(scope.row)" style="cursor: pointer;" @click="handleApprovalDetail(scope.row)">{{scope.row.relateApprovalStatusLabel}}</span>
                                </div>
                            </el-tooltip> -->
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="processServiceName"   :show-overflow-tooltip="true" label="流程方案" width="150"></el-table-column> -->
                    <el-table-column prop="startedBy.trueName" label="流程发起人" width="90"></el-table-column>
                    <el-table-column prop="assigneeUserName" label="流程负责人" width="90"></el-table-column>
                    <el-table-column prop="started" label="发起时间" width="140"></el-table-column>
                    <el-table-column  :show-overflow-tooltip="true" label="流程耗时" :sortable="true" width="95">
                      <template slot-scope="scope">
                       {{scope.row.processInstanceDurationTime}}
                      </template>
                   </el-table-column>
                    <el-table-column fixed="right" label="操作" width="200" >
                        <template slot-scope="scope">
                            <el-button icon="el-icon-view"  title="查看详情" @click="handleViewProcessDetail(scope.row)" circle></el-button>
                            <el-button v-if="scope.row.canViewDiagram" icon="el-icon-picture-outline" type="primary"  title='流程图'   @click="handelShowDiagram(scope.row)" circle></el-button>
                            <el-tooltip content="保存为常用负责人配置后，用该流程的流程模板发起流程时可以选择使用配置来快速发起流程" placement="top">
                                <!--本人发起的已完成流程，可以保存为常用配置。不可重复保存-->
                                <el-button type="primary" v-if="scope.row.finish && currentUserId===scope.row.startedBy.id && !scope.row.commonUse" title='保存为常用配置' size="mini" icon="el-icon-s-claim" circle @click="saveProcessCommonUseConfig(scope.row)"></el-button>
                            </el-tooltip>
                            <el-button type="primary" v-if="scope.row.finish && currentUserId===scope.row.startedBy.id && scope.row.commonUse" title='取消常用配置' size="mini" icon="el-icon-s-release" class="cancelBtn" circle @click="cancelProcessCommonUseConfigBOByProcesssId(scope.row)"></el-button>
                            <el-button v-if="scope.row.canCancelProcess || (scope.row.isUndoProcess && (scope.row.startedBy.id===currentUserId)) " title='删除流程' type="danger" plain icon="el-icon-delete" @click="handleCancelProcessInstances(scope.row)" circle></el-button>
                            <el-button v-if="scope.row.canCancelProcess && scope.row.processInstanceStatus !== 4 " title='终止流程' type="warning" plain icon="el-icon-remove" @click="handleTerminalProcessInstances(scope.row)" circle></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table
                      :key="loadTableTimer"
                      v-else-if="isProjectMainLine"
                      :height="tableHeight"
                      :style="tableStyle"
                      :data="instancesListTemp"
                      row-key="id"
                      :lazy="searchParams.complateTreeMode"
                      :load="loadProcessTreeChildren"
                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                      :border="true"
                      v-loading="loading">
                  <el-table-column type="index" label="序号" width="50"></el-table-column>
                  <el-table-column prop="name" label="流程名称" :show-overflow-tooltip="true">
                      <template slot-scope="scope">
                        <a href="javascript:void(0)" v-if="scope.row.mainQry || !searchParams.complateTreeMode" @click="handleViewProjectMainLine(scope.row)">{{scope.row.name}}</a>
                        <a href="javascript:void(0)" v-else style="color: #909399;">{{scope.row.name}}</a>
                      </template>
                  </el-table-column>
                  <el-table-column prop="templateName" label="流程模板" width="170" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column
                    label="当前任务"
                    :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope" >
                        <AsynCurrentTasksColumn
                            v-if="!scope.row.finish"
                            :readOnly="true"
                            :isShowOverflowTooltip="true"
                            :cellValue="scope.row['templateName']"
                            :processInstanceId="scope.row['id']"
                            :processInstanceName="scope.row['name']"
                            :processInstanceStatus="scope.row['processInstanceStatus']"
                            :createdByName="scope.row['assigneeUserName']"
                            :createdDate="scope.row['started']"
                            :columnRow="scope.row"
                            :rowNumer="scope.$index"
                            :closeFirstTaskCanDeleteBtn="searchParams.complateTreeMode"
                            @refreshTableBtn="refreshTableBtn"
                        />
                        <el-tag v-if="scope.row.finish" type="primary" size="small">流程已完成</el-tag>
                        <!-- <el-tooltip v-if="scope.row.hasApproval === '1'" content="多条审批流时默认只显示最近一条审批流状态" slot="reference"  effect="light" placement="top">
                          <div class="approvalStatus" style="font-size: 13px;">
                              <span :class="activeClass(scope.row)" style="cursor: pointer;" @click="handleApprovalDetail(scope.row)">{{scope.row.relateApprovalStatusLabel}}</span>
                          </div>
                      </el-tooltip> -->
                    </template>
                  </el-table-column> 
                  <el-table-column prop="startedBy.trueName" :show-overflow-tooltip="true"  label="发起人" width="70"></el-table-column>
                  <el-table-column prop="assigneeUserName" :show-overflow-tooltip="true"  label="负责人" width="70"></el-table-column>
                  <el-table-column prop="started" label="发起时间" :sortable="true" width="140"></el-table-column>
                  <el-table-column  :show-overflow-tooltip="true" label="流程耗时" :sortable="true" width="95">
                      <template slot-scope="scope">
                      {{scope.row.processInstanceDurationTime}}
                      </template>
                  </el-table-column>
                  <el-table-column label="流程角色" width="100">
                    <template slot-scope="scope">
                      <div v-if="searchParams.complateTreeMode">
                          <el-tag v-if="'1'===scope.row.role">我发起的</el-tag>
                          <el-tag v-else-if="'2'===scope.row.role" type="warning">我参与的</el-tag>
                          <el-tag v-else type="info">关联的</el-tag>
                      </div>
                      <div v-else>
                          <el-tag v-if="currentUserId===scope.row.startedBy.id" type="warning">我发起的</el-tag>
                          <el-tag v-else type="info">我参与的</el-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column   label="操作" width="225">
                      <template slot-scope="scope">
                          <el-button size="mini" title='流程图' circle icon="el-icon-picture-outline" @click="handelShowDiagram(scope.row)"></el-button>
                          <el-button v-if="scope.row.hasSubProcess==='1' && (scope.row.mainQry || !searchParams.complateTreeMode)" size="mini" icon="el-icon-s-grid" title="主子流程关系图" circle @click="handelShowProcessRelate(scope.row)"></el-button>
                          <el-button size="mini" v-if="scope.row.hasReports && scope.row.reportsCnt===1 && (scope.row.mainQry || !searchParams.complateTreeMode)" title="百川金字塔" class="iconfont icon-other-liucheng"  circle @click="handleShowOrgTreeView(scope.row)"></el-button>
                          <el-button size="mini" type="danger" v-if="(scope.row.canCancelProcess && (currentUserId===scope.row.startedBy.id || currentUserId===scope.row.assigneeUserId)) || (scope.row.isUndoProcess && (scope.row.startedBy.id===currentUserId)) " title='删除' circle icon="el-icon-delete" @click="handleCancelProcessInstances(scope.row)"></el-button>
                          <el-button size="mini" type="warning" v-if="scope.row.canCancelProcess && (currentUserId===scope.row.startedBy.id || currentUserId===scope.row.assigneeUserId) && scope.row.processInstanceStatus !== 4 " title='终止' circle icon="el-icon-remove" @click="handleTerminalProcessInstances(scope.row)"></el-button>
                          <el-button v-if="isViewAllFormsAuth" type="primary" title='表单库' size="mini" icon="el-icon-s-goods"  circle @click="showFormStores(scope.row)"></el-button>
                      </template>
                  </el-table-column>
              </el-table>
                <el-table
                    :key="loadTableTimer"
                    v-else
                    :height="tableHeight"
                    :style="tableStyle"
                    :data="instancesListTemp"
                    row-key="id"
                    :lazy="searchParams.complateTreeMode"
                    :load="loadProcessTreeChildren"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    :border="true"
                    :cell-class-name="cellStyle"
                    v-loading="loading">
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column prop="name" label="流程名称">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
                            <a href="javascript:void(0);" style="display: -webkit-box;-webkit-line-clamp: 1;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;width:89%;float:right;" v-if="scope.row.mainQry || !searchParams.complateTreeMode" @click="handleViewProcessDetail(scope.row)">{{scope.row.name}}</a>
                            <a href="javascript:void(0);" v-else style="color: #909399;display: -webkit-box;-webkit-line-clamp: 1;overflow: hidden;text-overflow: ellipsis;-webkit-box-orient: vertical;width:88%;float:right;">{{scope.row.name}}</a>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="templateName" label="流程模板" width="170" :show-overflow-tooltip="true"></el-table-column>
                <!-- <el-table-column
                    label="当前任务"
                    :show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope" >
                        <CurrentTasksColumn
                            v-if="!scope.row.finish"
                            :isFromBusTab="isFromBusTab"
                            :isShowOverflowTooltip="true"
                            :cellValue="scope.row['templateName']"
                            :taskInstanceList="scope.row['currentTasks']"
                            :processInstanceId="scope.row['id']"
                            :processInstanceName="scope.row['name']"
                            :createdByName="scope.row['assigneeUserName']"
                            :createdDate="scope.row['started']"
                            @navToMyTaskMyAssignee="navToMyTaskMyAssignee"
                            @navToBusiniessTaskTab="navToBusiniessTaskTab"
                            @refresh="handleSearch"
                        />
                        <el-tag v-if="scope.row.finish" type="primary" size="small">流程已完成</el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column
                  label="当前任务"
                  :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope" >
                      <AsynCurrentTasksColumn
                          v-if="!scope.row.finish"
                          :readOnly="true"
                          :isShowOverflowTooltip="true"
                          :cellValue="scope.row['templateName']"
                          :processInstanceId="scope.row['id']"
                          :processInstanceName="scope.row['name']"
                          :processInstanceStatus="scope.row['processInstanceStatus']"
                          :createdByName="scope.row['assigneeUserName']"
                          :createdDate="scope.row['started']"
                          :columnRow="scope.row"
                          :rowNumer="scope.$index"
                          :closeFirstTaskCanDeleteBtn="searchParams.complateTreeMode"
                          @refreshTableBtn="refreshTableBtn"
                      />
                      <el-tag v-if="scope.row.finish" type="primary" size="small">流程已完成</el-tag>
                      <!-- <el-tooltip v-if="scope.row.hasApproval === '1'" content="多条审批流时默认只显示最近一条审批流状态" slot="reference"  effect="light" placement="top">
                        <div class="approvalStatus" style="font-size: 13px;">
                            <span :class="activeClass(scope.row)" style="cursor: pointer;" @click="handleApprovalDetail(scope.row)">{{scope.row.relateApprovalStatusLabel}}</span>
                        </div>
                    </el-tooltip> -->
                  </template>
                </el-table-column> 
                <el-table-column prop="startedBy.trueName" :show-overflow-tooltip="true"  label="发起人" width="70"></el-table-column>
                <el-table-column prop="assigneeUserName" :show-overflow-tooltip="true"  label="负责人" width="70"></el-table-column>
                <el-table-column prop="started" label="发起时间" :sortable="true" width="140"></el-table-column>
                 <el-table-column  :show-overflow-tooltip="true" label="流程耗时" :sortable="true" width="95">
                    <template slot-scope="scope">
                     {{scope.row.processInstanceDurationTime}}
                    </template>
                 </el-table-column>
                <el-table-column label="流程角色" width="100">
                  <template slot-scope="scope">
                    <div v-if="searchParams.complateTreeMode">
                        <el-tag v-if="'1'===scope.row.role">我发起的</el-tag>
                        <el-tag v-else-if="'2'===scope.row.role" type="warning">我参与的</el-tag>
                        <el-tag v-else type="info">关联的</el-tag>
                    </div>
                    <div v-else>
                        <el-tag v-if="currentUserId===scope.row.startedBy.id" type="warning">我发起的</el-tag>
                        <el-tag v-else type="info">我参与的</el-tag>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column   label="操作" width="225">
                    <template slot-scope="scope">
                        <el-button size="mini" title='流程图' circle icon="el-icon-picture-outline" @click="handelShowDiagram(scope.row)"></el-button>
                        <el-button v-if="scope.row.hasSubProcess==='1' && (scope.row.mainQry || !searchParams.complateTreeMode)" size="mini" icon="el-icon-s-grid" title="主子流程关系图" circle @click="handelShowProcessRelate(scope.row)"></el-button>
                        <el-button size="mini" v-if="scope.row.hasReports && (scope.row.mainQry || !searchParams.complateTreeMode)" title='业务树关系图' circle icon="el-icon-connection" @click="handelShowReportRelateTree(scope.row)"></el-button>
                        <el-button size="mini" v-if="scope.row.hasReports && scope.row.reportsCnt===1 && (scope.row.mainQry || !searchParams.complateTreeMode)" title="百川金字塔" class="iconfont icon-other-liucheng"  circle @click="handleShowOrgTreeView(scope.row)"></el-button>
                        <el-button size="mini" type="danger" v-if="(scope.row.canCancelProcess && (currentUserId===scope.row.startedBy.id || currentUserId===scope.row.assigneeUserId)) || (scope.row.isUndoProcess && (scope.row.startedBy.id===currentUserId)) " title='删除' circle icon="el-icon-delete" @click="handleCancelProcessInstances(scope.row)"></el-button>
                        <el-button size="mini" type="warning" v-if="scope.row.canCancelProcess && (currentUserId===scope.row.startedBy.id || currentUserId===scope.row.assigneeUserId) && scope.row.processInstanceStatus !== 4 " title='终止' circle icon="el-icon-remove" @click="handleTerminalProcessInstances(scope.row)"></el-button>
                        <el-tooltip content="保存为常用负责人配置后，用该流程的流程模板发起流程时可以选择使用配置来快速发起流程" placement="top">
                            <!--本人发起的已完成流程，可以保存为常用配置。不可重复保存-->
                            <el-button type="primary" v-if="scope.row.finish && currentUserId===scope.row.startedBy.id && !scope.row.commonUse" title='保存为常用配置' size="mini" icon="el-icon-s-claim" circle @click="saveProcessCommonUseConfig(scope.row)"></el-button>
                        </el-tooltip>
                        <el-button type="primary" v-if="scope.row.finish && currentUserId===scope.row.startedBy.id && scope.row.commonUse" title='取消常用配置' size="mini" icon="el-icon-s-release" class="cancelBtn" circle @click="cancelProcessCommonUseConfigBOByProcesssId(scope.row)"></el-button>
                        <el-button v-if="isViewAllFormsAuth" type="primary" title='表单库' size="mini" icon="el-icon-s-goods"  circle @click="showFormStores(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
                <el-row type="flex" justify="end" v-if="tableStyle!=''">
                  <el-pagination
                      background
                      layout="sizes,total, prev, pager, next"
                      :total="page.totalPageNum"
                      :current-page="page.currentPage"
                      @size-change="handleSizeChange"
                      :page-size="page.pageSize"
                      @current-change="queryTableData"
                      :page-sizes="[10, 30, 50, 100]"
                  />
               </el-row>
            </el-main>
        </el-container>
        <el-dialog
            title="流程详情"
            :fullscreen=true
            :visible.sync="isShowProcessDetail"
            append-to-body
            >
            <ProcessDetail :key="loadTimer" :isFinish="isFinish" :instances="instancesInfo" :isCancel="isCancel" @reloadProcess="reloadProcess"/>
        </el-dialog>
        <el-drawer
            title="流程详情"
            :visible.sync="isShowProcessDetailDrawer"
            :direction="direction"
            size="90%"
            >
            <div style="margin-top: -20px;height: 100%;">
              <ProcessDetail :key="loadTimer" :isFinish="isFinish" :instances="instancesInfo" :isCancel="isCancel" :isShowNewMode="isShowNewMode" @reloadProcess="reloadProcess" :isFromBusTab="isFromBusTab" @navToBusiniessTaskTab="navToBusiniessTaskTab"/>
            </div>
        </el-drawer>
        <!-- 显示图标 -->
        <el-dialog
            title="流程图"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDiagram
              ref="processDiagrams"
              :key="loadTimer"
              :processInstance="instancesInfo"
              :taskList="taskList"
              :archiveTemplateTreeList="archiveTemplateTreeList"
              @refreshProcessList="handelProcessDetail"
            />
        </el-dialog>
        <el-dialog
            title="流程任务干预"
            width="80%"
            append-to-body
            :fullscreen=true
            :visible.sync="isShowSetting"
            @close="closeProcessSetting"
            >
            <ProcessSetting
              :processInstance="instancesInfo"
              :taskList="taskList"
              :archiveTemplateTreeList="archiveTemplateTreeList"
              @refreshProcessList="handelProcessDetail"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelProcessSetting">取 消</el-button>
                <!-- <el-button type="primary" @click="saveProcessSetting">保存配置</el-button> -->
            </span>
        </el-dialog>
         <el-dialog
            title="主子流程关系图"
            :fullscreen=true
            :visible.sync="isShowProcessRelate"
            append-to-body
            >
            <ProcessRelateTree :key="loadTimer" ref="processRelateTree" :processInstanceId ="currentProcessInstanceId" />
        </el-dialog>
        <el-dialog
            title="业务树关系图"
            custom-class="process-report-dialog"
            class="business-report-tree"
            :fullscreen=true
            :visible.sync="isShowReportRelateTree"
            append-to-body
            >
            <ProcessReportList :key="loadTimer" ref="reportRelateTree" :reports ="processReportList" />
        </el-dialog>
        <el-dialog
            title="流程动态信息列表"
            width="90%"
            :fullscreen=true
            :visible.sync="isShowPreview"
            >
            <ProcessAdjList ref="processAdjList" :processInstanceId="currentProcessInstanceId" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowPreview=false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="选择所属流程"
            :visible.sync="isShowProcessListDialog"
            append-to-body
            width = "60%">
            <ProcessPop  :field="{}" ref="processSelect" :formData="{}" @nodeClick="selectTrigger"/>
            <span slot="footer" class="dialog-footer">
                <el-button  type="primary" @click="handleClickOk">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title=""
            :visible.sync="isShowOrgTreeDialog"
            :fullscreen = true
            append-to-body
            >
            <VueOrgTree ref="reportOrgTree" :key="vueOrgTreeLoadTimer" :treeData="treeOrgData"/>
        </el-dialog>
        <el-dialog
            title="任务表单库"
            top="1vh"
            width="80%"
            :key="loadTimer"
            :fullscreen=true
            append-to-body
            :visible.sync="isShowForms">
            <ProcessForms v-if="isShowForms" :processInfo="processInfo" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowForms=false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="项目主线列表"
            append-to-body
            :fullscreen="true"
            :visible.sync="isShowFullScreenForMainLine"
            @close="hideFullScreenProjectMainLine">
            <ProjectMainLineDetail 
                :key="loadTimerProject"
                ref="projectMainLineDetail"
                :isInstance="true"
                :instancesInfo="instancesInfo"
                :ifConfigMainLine="ifConfigMainLine"
                @handleFullScreenForMainLine="handleFullScreenForMainLine"
                @initProjectMainLine="initProjectMainLine" />
                <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowFullScreenForMainLine=false">取 消</el-button>
                </span>
        </el-dialog>
        <el-dialog
            title="审批流进度"
            top="4vh"
            width="75%"
            :visible.sync="isShowDynamicApprovalPop"
            append-to-body
          >
            <DynamicApprovalPop
                :isStatus="true"
                :approvalDetail="approvalDetail"
                :cellValue="1"
            />
        </el-dialog>
    </div>
</template>

<script>
    import { clone, isEmpty } from 'lodash';
    import {
        getPublishedApplicationList,
        saveProcessTreeListQry,
        getConstantBOMap,
        getProcessInstanceTreeList,
        getProcessInstanceTreeChildren,
        cancelProcessCommonUseConfigBOByProcesssId,
        saveProcessCommonUseConfig,
        getProcessInstancesList,
        getProcessInstancesDetail,
        cancelProcessInstance,
        deleteProcessInstance,
        terminalProcessInstance,
        getAllUserTask,
        getArchiveTemplateTreeList,
        getProcessTemplateList,
        getModelFormReportOrgTree,
        getModelFormReportTree,
        getExcelCommonDataExportId,
        getApprovalInstanceDetail
        // getProcessAllFormInstances
    } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import ProcessRelateTree from '@/components/ProcessRelateTree';
    import ProcessAdjList from '@/components/ProcessAdjList';
    import ProcessReportList from '@/pages/process/MyProcess/ProcessReportList';
    import CurrentTasksColumn from './CurrentTasksColumn';
    import AsynCurrentTasksColumn from '@/pages/process/MyProcess/AsynCurrentTasksColumn';
    import { API_EXPORT_MODEL_EXPORT_PROCESS_EXCEL_BY_EXPORTID } from '@/common/constants';
    import ProcessForms from '@/pages/process/MyProcess/ProcessForms';
    import VueOrgTree from '@/components/VueOrgTree';
    import ProjectMainLineDetail from '@/pages/workbench/ProjectMainLine/ProjectMainLineDetail';
    import DynamicApprovalPop from '@/components/DynamicTable/DynamicApprovalPop';
    export default {
        mixins: [ mixinsNav ],
        components: {
            // ProcessDetail,
            // ProcessDiagram,
            ProcessRelateTree,
            ProcessAdjList,
            ProcessReportList,
            VueOrgTree,
            CurrentTasksColumn,
            AsynCurrentTasksColumn,
            ProcessForms,
            ProjectMainLineDetail,
            DynamicApprovalPop
        },
        mounted () {
            this.$nextTick(() => {
                // console.log(this.instancesListTemp);
                this.loadTableTimer = new Date().getTime();
            });
        },
        data () {
            return {
                selectedAppId: '',
                selectedApp: {},
                currentTemplateList: [],
                appsList: [],
                selectedProcessServiceIdArray: '',
                vueOrgTreeLoadTimer: '',
                treeOrgData: {},
                isShowOrgTreeDialog: false,
                isShowProcessListDialog: false,
                processStartedBy: '', // 默认全部 1我发起2我参与
                processStartedByList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '1',
                        label: '我发起'
                    }, {
                        value: '2',
                        label: '我参与'
                    }],
                currentCnt: 0,
                instancesListTempCnt: 0,
                instancesListTemp: [], // 临时列表
                instancesList: [], // 列表数据
                loading: false, // 列表的loading状态
                searchKeyWord: '', // 查询的关键字,
                processInstanceId: '', // 流程实例ID
                instancesInfo: {},
                isFinish: false,
                isCancel: false,
                isShowProcessDetail: false,
                isShowProcessDetailDrawer: false,
                direction: 'rtl',
                isShowDiagram: false,
                taskList: [],
                archiveTemplateTreeList: [],
                isShowSetting: false,
                isReloadProcess: false,
                loadTimer: '',
                currentUserId: '',
                currentUserName: '',
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                currentProcessInstanceId: '',
                isShowProcessRelate: false,
                isShowReportRelateTree: false,
                processReportList: [], // 当前流程绑定的报表
                searchParams: {
                    complateTreeMode: false,
                    pageSize: 100000,
                    currentPage: 1,
                    processServiceId: '', // 流程模板对应的方案ID
                    startedByUserId: '', // 流程发起人ID
                    assigneeUserId: '', // 流程负责人Id
                    hasSubProcess: '', // 默认全部
                    isTree: false, // 树列表结构
                    allProcessInstance: true, // 查询所有流程实例
                    processStartedBy: '', // 默认全部1我发起2我参与
                    serviceName: '',
                    state: this.processState ? this.processState : '' // 流程状态 ：默认 全部
                },
                selectedStartedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowStartedUserOrg: false,
                selectedProcessUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowProcessUserOrg: false,
                processTemplateList: [],
                processStateList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '进行中'
                    }, {
                        value: 2,
                        label: '已完成'
                    }, {
                        value: 4,
                        label: '已终止'
                    }],
                processInstanceTypeList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '0',
                        label: '不含子流程'
                    }, {
                        value: '1',
                        label: '含子流程'
                    }],
                isShowPreview: false,
                processList: [],
                processNameLoading: false,
                isShowForms: false,
                processInfo: {},
                isShowFullScreenForMainLine: false,
                loadTimerProject: '',
                ifConfigMainLine: false,
                loadTableTimer: '',
                approvalDetail: {},
                isShowDynamicApprovalPop: false,
                isViewAllFormsAuth: false
            };
        },
        props: {
            processState: {// 默认进行中
                type: [String, Number],
                default: 1 // 流程状态 ：默认 进行中
            },
            tableHeight: {
                type: Number,
                default: 450
            },
            tableStyle: {
                type: String,
                default: 'width: 100%;'
            },
            taskInfo: {
                type: Object
            },
            hideModeSwich: {
                type: Boolean,
                default: false
            },
            isShowNewMode: {// 查询形式 false: 旧版 true：新版
                type: Boolean,
                default: false
            },
            role: {
                type: String,
                default: ''
            },
            isFromBusTab: {
                type: Boolean,
                default: false
            },
            isListView: {// 我的流程列表模式：true 块模式 false
                type: Boolean,
                default: false
            },
            isSubProcessShow: {// 是否显示子流程列表
                type: Boolean,
                default: false
            },
            isSearchNowTasks: {
                type: Boolean,
                default: false
            },
            isProjectMainLine: {
                type: Boolean,
                default: false
            },
            subProcessList: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // this._initPage();
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                this.currentUserId = currentUserInfo.userId;
                this.currentUserName = currentUserInfo.trueName;
            }
            this.viewAllFormsAuth();
            this.getApplications();
            // this._getFormData();
        },
        methods: {
            async _initPage () {
                this.isShowProcessDetail = false;
                this.isShowProcessDetailDrawer = false;
                this._getFormData();
            },
            async getApplications () {
                if (this.isShowNewMode) {
                    this.appsList = await getPublishedApplicationList();
                }
            },
            clearSelectedAppId () {
                this.selectedProcessServiceIdArray = '';
                this.searchParams.processServiceId = '';
                this.currentTemplateList = this.processTemplateList;
                this.handleSearch();
            },
            changeSelectedAppId () {
                // console.log(this.selectedAppId);
                this.selectedProcessServiceIdArray = '';
                this.searchParams.processServiceId = '';
                if (this.selectedAppId) {
                    // 根据APPId获取应用
                    for (let j = 0; j < this.appsList.length; j++) {
                        let app = this.appsList[j];
                        if (app.id === this.selectedAppId) {
                            this.selectedApp = app;
                        }
                    }
                    // 根据应用获取绑定的流程模板
                    if (this.selectedApp) {
                        if (!isEmpty(this.selectedApp.processServiceIds)) {
                            let processServiceIds = this.selectedApp.processServiceIds.split(',');
                            let processServiceNames = this.selectedApp.processServiceNames.split(',');
                            let selectedData = [];
                            for (let i = 0; i < processServiceIds.length; i++) {
                                selectedData.push({processServiceId: processServiceIds[i], templateName: processServiceNames[i]});
                            }
                            this.currentTemplateList = selectedData;

                            this.searchParams.processServiceId = this.selectedApp.processServiceIds;
                            // 刷新流程列表信息
                            this._getFormData();
                        } else {
                            this.currentTemplateList = [];
                        }
                    } else {
                        this.currentTemplateList = this.processTemplateList;
                    }
                } else {
                    this.currentTemplateList = this.processTemplateList;
                }
            },
            // 查询保存的模式选项值
            async getConstantBOMap () {
                let defaultParam = await getConstantBOMap('/process/processInstance/getProcessInstanceTreeList');
                // console.log(defaultParam);
                if (defaultParam && defaultParam.hasOwnProperty('complateTreeMode')) {
                    if (defaultParam.complateTreeMode === '1') {
                        this.searchParams.complateTreeMode = true;
                        this.searchParams.isTree = true;
                    } else {
                        this.searchParams.complateTreeMode = false;
                        this.searchParams.isTree = false;
                    }
                }
            },
            async _getFormData () {
                // 先查询出默认的模式，然后在查询
                this.getConstantBOMap().then(val => {
                    this.getProcessListView();
                });
            },
            showFormStores (obj) {
                if (this.isViewAllFormsAuth) {
                    this.processInfo.serviceName = obj.processServiceName;
                    this.processInfo.instanceName = obj.name;
                    this.processInfo.processInstanceId = obj.id;
                    this.processInfo.deploymentId = obj.deploymentId;
                    this.loadTimer = new Date().getTime();
                    this.isShowForms = true;
                } else {
                    this.$message({
                        message: '您无查看当前流程的任务表单库和流程图权限，若想查看请联系管理员！',
                        type: 'warning',
                        duration: 3000
                    });
                }
            },
            viewAllFormsAuth () {
                this.isViewAllFormsAuth = false;
                let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
                if (currentUserStr) {
                    let currentUserInfo = JSON.parse(currentUserStr);
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'AllProcessInstanceData') { // 是否可以查看所有流程(同时也包括查看非自己负责的所有任务)
                                this.isViewAllFormsAuth = true;
                                break;
                            }
                        }
                    }
                }
            },
            async getProcessListView () {
                this.loading = true;
                if (this.searchParams.isTree) { // 全树模式下去掉该参数
                    this.searchParams.processStartedBy = '';
                    this.processStartedBy = '';
                }
                let params = {
                    pageSize: 1000,
                    currentPage: 1,
                    serviceName: this.searchKeyWord,
                    state: this.processState,
                    processStartedBy: this.processStartedBy
                };
                if (!isEmpty(this.role)) {
                    let tempProcessStartedBy = '';
                    if (this.role === 'startedBy') {
                        tempProcessStartedBy = '1';
                    } else if (this.role === 'participant') {
                        tempProcessStartedBy = '2';
                    } else if (this.role === 'assignee') {
                        tempProcessStartedBy = '3';
                        this.selectedProcessUser = {
                            selectedUserIds: this.currentUserId,
                            selectedUserNames: this.currentUserName
                        };
                        this.searchParams.assigneeUserId = this.selectedProcessUser.selectedUserIds;
                    };
                    params.processStartedBy = tempProcessStartedBy;
                    this.searchParams.processStartedBy = tempProcessStartedBy;
                    this.processStartedBy = tempProcessStartedBy;
                }
                if (this.taskInfo) {
                    params.relationProcessInstanceId = this.taskInfo.processInstanceId;
                    params.relationTaskInstanceId = this.taskInfo.id;
                }
                if (this.subProcessList) {
                    params.fromSubProcess = true;
                    this.searchParams.fromSubProcess = true;
                }
                if (this.searchParams.isTree) { // 全树模式下去掉该参数
                    this.searchParams.processStartedBy = '';
                    this.processStartedBy = '';
                }
                let formData;
                if (!this.isShowNewMode) {
                    params.isSearchNowTasks = this.isSearchNowTasks;
                    if (this.isProjectMainLine) { // 项目主线只查主流程
                        params.processMode = 1;
                    }
                    // params.isSearchNowTasks = false;
                    formData = await getProcessInstancesList(params);
                } else { // 新版本列表展示流程实例
                    // this.searchParams.state = this.processState;
                    // this.searchParams.isSearchNowTasks = true;// 否查询当前所在任务节点信息
                    this.searchParams.isSearchNowTasks = this.isSearchNowTasks;// 否查询当前所在任务节点信息
                    // 1、我的任务跳转过来的 2、发起流程调过来的
                    let processInstanceStr = window.sessionStorage.getItem('navToProcessList');
                    let processInstanceId = '';// 需要自动打开详情的流程
                    if (processInstanceStr) {
                        let processInstanceInfo = JSON.parse(processInstanceStr);
                        // console.log(processInstanceInfo);
                        this.searchParams.serviceName = processInstanceInfo.processInstanceName;
                        processInstanceId = processInstanceInfo.processInstanceId;
                    }
                    window.sessionStorage.removeItem('navToProcessList');

                    // formData = await getProcessTimeTreeList(Object.assign({}, {
                    //     currentPage: this.page.currentPage,
                    //     pageSize: this.page.pageSize
                    // }, this.searchParams));
                    formData = await getProcessInstanceTreeList(Object.assign({}, {
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize,
                        lazyTreeMode: this.searchParams.complateTreeMode
                    }, this.searchParams));

                    // 打开任务详情
                    if (processInstanceId) {
                        let item = {};
                        item.id = processInstanceId;
                        this.handleViewProcessDetail(item);
                    }
                }
                if (formData) {
                    this.instancesList = formData.data;
                    if (!this.isShowNewMode) {
                        this.page.totalPageNum = this.instancesList.length;
                    } else {
                        this.page.totalPageNum = formData.totalPageNum;
                    }
                    this.dealData();
                    this.loadTableTimer = new Date().getTime();
                    if (this.isShowNewMode) {
                        await this.initProcessTemplateList();
                    }
                }
                // this.queryProcessList('');
                this.loading = false;
            },
            handleSearch () {
                this.searchParams.processServiceId = '';
                for (const id of this.selectedProcessServiceIdArray) {
                    if (isEmpty(this.searchParams.processServiceId)) {
                        this.searchParams.processServiceId = id;
                    } else {
                        this.searchParams.processServiceId = this.searchParams.processServiceId + ',' + id;
                    }
                }
                this.page.currentPage = 1;
                this._getFormData();
            },
            async loadProcessTreeChildren (row, treeNode, resolve) {
                if (!this.searchParams.complateTreeMode || !row || !row.id) {
                    resolve([]);
                    return;
                }
                try {
                    const formData = await getProcessInstanceTreeChildren(Object.assign({}, this.searchParams, {
                        parentProcessInstanceId: row.id,
                        currentPage: 1,
                        pageSize: 100000
                    }));
                    resolve(formData && formData.data ? formData.data : []);
                } catch (e) {
                    this.$message({message: '加载子流程失败，请稍后重试', type: 'warning'});
                    resolve([]);
                }
            },
            queryTableData (currentPage) {
                this.page.currentPage = currentPage;
                this.dealData();
            },
            async  handleViewProcessDetail (row) {
                // console.log(row);
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.instancesInfo = await getProcessInstancesDetail(row.id);
                tempLoading.close();
                this.isCancel = false;
                this.loadTimer = new Date().getTime();
                if (this.isShowNewMode) {
                    this.isShowProcessDetailDrawer = true;
                } else {
                    this.isShowProcessDetail = true;
                }
            },
            handleModeSwitch () {
                this.$emit('handleModeSwitch', 'block');
            },
            async reloadProcess (processInstanceId, isUpdName) {
                this.isShowProcessDetail = false;
                this._initPage();
            },
            async handleCancelProcessInstances (instances) {
                let tempLoading = '';
                this.$confirm(`您确定要删除流程[ ${instances.name} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$confirm('删除流程时，是否同时级联删除当前流程关联对应的表单、文件及子流数据数据？请慎重选择', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '级联数据全部删除',
                        cancelButtonText: '只删除流程',
                        type: 'warning'
                    }).then(async () => {
                        await cancelProcessInstance(instances.id);
                        tempLoading.close();
                        // this.reloadProcess();
                        this._initPage();
                    }).catch(async action => {
                        if (action === 'cancel') {
                            await deleteProcessInstance(instances.id);
                            tempLoading.close();
                            // this.reloadProcess();
                            this._initPage();
                        } else {
                            tempLoading.close();
                        }
                    });
                }).catch(() => {
                    tempLoading.close();
                });
            },
            async handleTerminalProcessInstances (instances) {
                this.$confirm(`您确定要终止流程[ ${instances.name} ]吗？这会导致流程直接完成不可恢复，请谨慎处理。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.$confirm('终止流程时，是否级联终止当前流程内表单数据所关联的数据也变为终止状态？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '否',
                        cancelButtonText: '是',
                        type: 'warning'
                    }).then(async () => {
                        await terminalProcessInstance({processInstanceId: instances.id, isCascade: false});// 否
                        tempLoading.close();
                        this._initPage();
                    }).catch(async action => {
                        if (action === 'cancel') {
                            await terminalProcessInstance({processInstanceId: instances.id, isCascade: true});// 是
                            tempLoading.close();
                            this._initPage();
                        } else {
                            tempLoading.close();
                        }
                    });
                }).catch(() => {
                });
            },
            async handelShowDiagram (instances) {
                this.instancesInfo = instances;
                await this.setProcessViewInfo(instances);
                this.loadTimer = new Date().getTime();
                this.isShowDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.processDiagrams.setProcessState(this.isFinish);
                    this.$refs.processDiagrams.resetDiagramUrl();
                }, 0);
            },
            async handelProcessDetail (isReloadProcess) {
                await this.setProcessViewInfo(this.instancesInfo);
                this.isShowSetting = true;
                this.isReloadProcess = isReloadProcess;
            },
            async setProcessViewInfo (instances) {
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let tasks = await getAllUserTask(instances.id, instances.processServiceId, null, instances.deploymentId);
                this.taskList = tasks;
                let treeList = [];
                if (instances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: instances.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                tempLoading.close();
            },
            cancelProcessSetting () {
                if (this.isReloadProcess) {
                }
                this.isShowSetting = false;
            },
            closeProcessSetting () {
                if (!this.isCancel) {
                    if (this.isReloadProcess) {

                    }
                    this.isShowSetting = false;
                }
            },
            loadMore () {
                // this.$message.success('加载下一页');
                this.currentCnt = this.instancesList.length;
                // console.log(this.currentCnt);
                if (this.currentCnt < this.instancesListTempCnt) {
                    let item = clone(this.instancesListTemp[this.currentCnt]);
                    // console.log(item);
                    this.instancesList.push(item);
                }
            },
            handleSizeChange (val) {
                this.page.pageSize = val;
                this.dealData();
            },
            dealData () {
            // 分页操作，每次取当前页*每页显示的条数再加每页显示的条数
                let cpage = (this.page.currentPage - 1) * this.page.pageSize;
                let count = this.page.pageSize + cpage;
                if (this.instancesList && this.instancesList.length > 0) {
                    this.instancesListTemp = this.instancesList.slice(cpage, count);
                } else {
                    this.instancesListTemp = [];
                }
            },
            async handelShowProcessRelate (row) {
                this.loadTimer = new Date().getTime();
                this.currentProcessInstanceId = row.id;
                setTimeout(() => {
                    this.$refs.processRelateTree._initPage();
                }, 0);
                this.isShowProcessRelate = true;
            },
            async handelShowReportRelateTree (item) {
                this.loadTimer = new Date().getTime();
                // this.processReportList = item.reports;
                let instancesInfo = await getProcessInstancesDetail(item.id);
                this.processReportList = instancesInfo.reports;
                setTimeout(() => {
                    this.$refs.reportRelateTree._initPage();
                }, 0);
                this.isShowReportRelateTree = true;
            },
            chooseProcessAssigneeUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.processUserOrgPop._initPage();
                }, 0);
                this.isShowProcessUserOrg = true;
            },
            processAssigneeSelectTrigger (selected) { // 流程负责人
                this.selectedProcessUser = selected;
                this.searchParams.assigneeUserId = selected.selectedUserIds;
                this.handleSearch();
                this.loadTimer = new Date().getTime();
            },
            chooseProcessStartedUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.startedUserOrgPop._initPage();
                }, 0);
                this.isShowStartedUserOrg = true;
            },
            processStartedUserSelectTrigger (selected) { // 流程发起人
                this.selectedStartedUser = selected;
                this.searchParams.startedByUserId = selected.selectedUserIds;
                this.handleSearch();
                this.loadTimer = new Date().getTime();
            },
            async initProcessTemplateList () {
                let { data } = await getProcessTemplateList({ state: 1, currentPage: 0, pageSize: 500 });// 查出最新版本的流程方案
                this.processTemplateList = data;
                this.currentTemplateList = data;
            },
            async processRecordView (row) {
                this.loadTimer = new Date().getTime();
                this.instancesInfo = row;
                this.currentProcessInstanceId = this.instancesInfo.id;
                // console.log("当前流程实例ID"+this.currentProcessInstanceId);
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.processAdjList._initPage();
                }, 0);
                this.isShowPreview = true;
            },
            handleStartProcess () {
                this.$emit('handleTemplateSwitch', true);
            },
            chooseProcess () {
                this.isShowProcessListDialog = true;
            },
            selectTrigger (selected) { // 选择流程
                this.searchParams.serviceName = selected.label;
            },
            selectProcessNameTrigger (id) { // 选择流程
                let selected = {id: '', label: ''};
                if (id) {
                    selected = this.processList.find((item) => {
                        return item.id === id;
                    });
                }
                this.searchParams.serviceName = selected.name;
                this.handleSearch();
            },
            async handleClickOk () {
                this.isShowProcessListDialog = false;
                // 选完流程后自动查询
                this.handleSearch();
            },
            navToBusiniessTaskTab () {
                this.$emit('navToBusiniessTaskTab');
                this.isShowProcessDetailDrawer = false;
            },
            async queryProcessList (name) {
                this.processNameLoading = true;
                let processInstances = await getProcessInstancesList({
                    pageSize: 1000,
                    currentPage: 1,
                    serviceName: name,
                    state: this.processState
                });
                if (processInstances && processInstances.data) {
                    this.processList = processInstances.data;
                }

                this.processNameLoading = false;
            },

            async handleShowOrgTreeView (row) {
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(async () => {
                    let instancesInfo = await getProcessInstancesDetail(row.id);

                    let searchParams = {
                        isAllData: false,
                        modelId: '',
                        name: '',
                        selectedFields: '',
                        searchCondition: [],
                        selectedApprovalStatus: ''
                    };
                    searchParams.modelId = instancesInfo.reports[0].modelId;
                    searchParams.formId = instancesInfo.reports[0].formId;
                    searchParams.isFilterDuplicateData = true;
                    searchParams.processInstanceId = row.id;
                    let formData = await getModelFormReportTree(Object.assign({}, {
                        currentPage: 1,
                        pageSize: 10
                    }, searchParams));
                    let treeData = [];
                    if (formData.data) {
                        let tableDatas = [];
                        formData.data.forEach(item => {
                            let jsonObj = JSON.parse(item);
                            tableDatas.push(jsonObj);
                        });
                        treeData = tableDatas;
                    }
                    if (treeData && treeData.length > 0) {
                        let formData = await getModelFormReportOrgTree(instancesInfo.reports[0].formId, treeData[0].id);
                        this.treeOrgData = {};
                        if (formData.data) {
                            let tableDatas = {};
                            formData.data.forEach(item => {
                                tableDatas = JSON.parse(item);
                            });
                            this.treeOrgData = tableDatas;
                        }
                        this.isShowOrgTreeDialog = true;
                    } else {
                        this.$message({ message: '暂时没有数据', type: 'warning', uration: 3000 });
                    }
                    tempLoading.close();
                }, 0);
            },
            navToMyTaskMyAssignee () {
                this.navMyTaskMyAssignee();// 我负责
            },
            async saveProcessCommonUseConfig (row) {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let tasks = await getAllUserTask(row.id, row.processServiceId, null, row.deploymentId);
                let taskConfigInfo = JSON.stringify(tasks);
                let param = {
                    processServiceId: row.processServiceId,
                    deploymentId: row.deploymentId,
                    processInstanceId: row.id,
                    processInstanceName: row.name,
                    processDefinitionId: row.processDefinitionId,
                    taskConfigInfo: taskConfigInfo

                };
                await saveProcessCommonUseConfig(param);
                this.handleSearch();
                loading.close();
            },
            async cancelProcessCommonUseConfigBOByProcesssId (row) {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await cancelProcessCommonUseConfigBOByProcesssId(row.id);
                this.handleSearch();
                loading.close();
            },
            async handleByMeModeChange () {
                let param = {
                    keyStr: 'complateTreeMode',
                    valueStr: this.searchParams.complateTreeMode ? 1 : 0
                };
                await saveProcessTreeListQry(param);
                this._initPage();
            },
            changeMenuMode () {
                this.$emit('changeMenuMode');
            },
            async exportData () {
                let res = await getExcelCommonDataExportId(this.searchParams);
                let url = `${API_EXPORT_MODEL_EXPORT_PROCESS_EXCEL_BY_EXPORTID}`;
                url = url.replace(':exportId', res.data);
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            async  handleViewProjectMainLine (row) {
                this.instancesInfo = row;
                this.isCancel = false;
                this.loadTimerProject = new Date().getTime();
                this.isShowFullScreenForMainLine = true;
                this.ifConfigMainLine = true;
                let projectMainLineObj = {
                    processInstanceId: row.id
                };
                setTimeout(() => {
                    this.$refs.projectMainLineDetail._initPage(projectMainLineObj);
                }, 0);
            },
            hideFullScreenProjectMainLine () {
                this.isShowFullScreenForMainLine = false;
            },
            handleFullScreenForMainLine () {
                this.isShowFullScreenForMainLine = false;
            },
            initProjectMainLine () {
                // this.loadTimerProject = new Date().getTime();
                // let projectMainLineObj = {
                //     id: this.instances.timeTemplateId,
                //     processInstanceId: this.instances.id
                // };
                // setTimeout(() => {
                //     this.$refs.projectMainLineDetail._initPage(projectMainLineObj);
                // }, 0);
                // this.isShowTimeConfigDetail = true;
            },
            cellStyle ({ row, column, columnIndex }) {
                if (columnIndex === 1) {
                    return 'treeTableName';
                }
            },
            refreshTableBtn (row, rowNumer) {
                this.instancesListTemp[rowNumer] = row;
                this.$set(this.instancesListTemp, rowNumer, row);
                this.loadTableTimer = new Date().getTime();
            },
            activeClass (item) {
                let approvalStatus = 0;
                if (item.relateApprovalStatusList) {
                    if (item.relateApprovalStatusList.indexOf(',') !== -1) {
                        approvalStatus = item.relateApprovalStatusList.split(',')[0];
                    } else {
                        approvalStatus = item.relateApprovalStatusList;
                    }
                    // 1审批中 2通过 3驳回
                    if (approvalStatus === '1') {
                        item.relateApprovalStatusLabel = '进行中';
                        return 'doing';
                    } else if (approvalStatus === '2') {
                        item.relateApprovalStatusLabel = '通过';
                        return 'success';
                    } else if (approvalStatus === '3') {
                        item.relateApprovalStatusLabel = '驳回';
                        return 'reject';
                    } else if (approvalStatus === '4') {
                        item.relateApprovalStatusLabel = '已终止';
                        return 'terminal';
                    } else {
                        return '';
                    }
                }
            },
            async handleApprovalDetail (record) {
                this.approvalDetail = {};
                let approvalInstanceId;
                if (record.relateApprovalInstanceIdList) {
                    if (record.relateApprovalInstanceIdList.indexOf(',') !== -1) {
                        approvalInstanceId = record.relateApprovalInstanceIdList.split(',')[0];
                    } else {
                        approvalInstanceId = record.relateApprovalInstanceIdList;
                    }
                }
                if (approvalInstanceId) {
                    let loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    this.approvalDetail = await getApprovalInstanceDetail(approvalInstanceId);
                    this.isShowDynamicApprovalPop = true;
                    loading.close();
                }
            }
        }
    };
</script>

<style lang="less">
    .myProcessListView-list {
        height: 100%;
        width: 100%;
        margin-top: -14px;
        .tools-bar {
            position:fixed;
            width:100%;
            height:auto;
            overflow-y:auto;
            min-height: 40px;
            justify-content: flex-start;
        }
        .table-main {
            // height:540px;
            overflow-y:auto;
        }
        a{
            font-size:15px;
            text-decoration:none; //去掉默认下滑线
            color: #3F51B5; //设置默认颜色
        }
        a:hover{
            text-decoration:none;//鼠标放上面不显示下划线
            color:#409eff; //设置鼠标放上去颜色
        }
        .cancelBtn{
            background-color: #f56c6c;
            border-color: #f56c6c;
        }
        .treeTableName{
            .cell{
                .el-table__placeholder{
                    display: none;
                }
            }
        }
    }
    .business-report-tree{
        .process-report-dialog{
            .el-dialog__body{
                height: ~'calc(100% - 10vh)';
                margin-top: -2vh;
                padding: 20px 20px;
            }
        }
    }
    .el-tooltip {
        .approvalStatus {
          .doing{
                color: #409eff;
                border-color: #409eff; 
            } 
            .success{
                color: #67c23a;
                border-color: #67c23a;
            }
            .reject{
                color: #f56c6c;
            }
            
            .terminal{
                color: #E6A23C;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/MyProcessListView.vue